// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__OhAk5","productName":"Table_productName__2-AP3"};